import { render, staticRenderFns } from "./PosCounterContent.vue?vue&type=template&id=c855897c"
import script from "./PosCounterContent.vue?vue&type=script&lang=js"
export * from "./PosCounterContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports